"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a, _b, _c;
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable prefer-destructuring */
const core_1 = require("@angular/core");
const customer_1 = require("../shared/models/customer/customer");
const offer_1 = __importDefault(require("../shared/models/offer/offer"));
const toast_service_1 = require("../../../ui-components/toast/toast.service");
let OfferSendingForm = class OfferSendingForm {
    constructor(customerModel, offerModel, toastService) {
        this.customerModel = customerModel;
        this.offerModel = offerModel;
        this.toastService = toastService;
        this.customer = null;
        this.sending = false;
        this.offerRequest = {
            offerId: '',
            email: '',
            text: '',
        };
        this.uploadedFiles = [null, null, null];
        this.sendOffer = () => __awaiter(this, void 0, void 0, function* () {
            this.sending = true;
            const files = this.uploadedFiles.flatMap((f) => (f ? [f] : []));
            yield this.offerModel.sendOffer(this.offerRequest, files);
            this.toastService.toast(toast_service_1.ToastType.SUCCESS, 'E-Mail an Kunden gesendet');
            this.exit();
        });
        this.changeFile = (index, event) => {
            const element = event.target;
            const { files } = element;
            if (files === null || files === void 0 ? void 0 : files.length)
                this.uploadedFiles[index] = files[0];
        };
    }
    ngOnInit() {
        return __awaiter(this, void 0, void 0, function* () {
            this.offerRequest.offerId = this.offer.id;
            this.customer = yield this.customerModel.get(this.offer.customerId);
            this.offerRequest.email = this.customer.email;
            this.offerRequest.text = `${yield this.customerModel.getFormalSalutation(this.customer.id, this.customer)},\n
ich freue mich Ihnen Ihr persönliches Angebot zu übersenden. \n
Über den folgenden Link erhalten Sie alle wichtigen Informationen zu Fahrzeug und Angebot.\n
Bei Rückfragen stehe ich Ihnen jederzeit zur Verfügung.`;
        });
    }
};
__decorate([
    (0, core_1.Input)(),
    __metadata("design:type", Object)
], OfferSendingForm.prototype, "offer", void 0);
__decorate([
    (0, core_1.Input)(),
    __metadata("design:type", Function)
], OfferSendingForm.prototype, "exit", void 0);
OfferSendingForm = __decorate([
    (0, core_1.Component)({
        selector: 'offer-sending-form',
        templateUrl: require('./offer-sending.component.html'),
    }),
    __metadata("design:paramtypes", [typeof (_a = typeof customer_1.CustomerModel !== "undefined" && customer_1.CustomerModel) === "function" ? _a : Object, typeof (_b = typeof offer_1.default !== "undefined" && offer_1.default) === "function" ? _b : Object, typeof (_c = typeof toast_service_1.ToastService !== "undefined" && toast_service_1.ToastService) === "function" ? _c : Object])
], OfferSendingForm);
exports.default = OfferSendingForm;
